module.exports = __webpack_public_path__ + "static/media/medicine@3x.ccb4a225.png";